import { capitalize } from 'lodash';

/**
 * Used as fallback when the display name does not exist in the formatters.
 * It just capitalizes the first letter and replaces underscores with spaces.
 */
export const formatSlugToDisplayName = (value: string) => {
  return capitalize(value.replace(/_/g, ' '));
};
